import React, {Component, PropTypes} from 'react';
import { RequiredLabel } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './checkbox-element.style.js';

// Eventually this should use a legend/fieldset, but there is currently an open nvda bug preventing this from working for screen readers
// NVDA bug: https://github.com/nvaccess/nvda/issues/3321
export class CheckboxElement extends Component {
  isChecked(value) {
    const { response, defaultValue } = this.props;

    if(response !== undefined)
      return !!response && response.indexOf(value) !== -1;
    else
      return !!defaultValue && defaultValue.indexOf(value) !== -1;
  }

  render() {
    const { isRequired, label, options, id, onChange, disabled, errors, showErrors,  css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');

    return (
      <fieldset
        id={id}
        role="group"
        className={css.fieldset}>
        <RequiredLabel hasErrors={hasErrors && showErrors} content={label} isRequired={isRequired}/>
        {options.map(option => (
          <div key={`${id}-${option.value}`}>
            <label className={css.buttonLabel} htmlFor={option.id}>
              <input
                name={'group' + id}
                id={option.id}
                className={css.checkbox}
                type="checkbox"
                disabled={disabled}
                value={option.value}
                onChange={e => onChange(e.target.value, e.target.checked)}
                checked={this.isChecked(option.value)}
                aria-label={label + ' ' + option.label}
                aria-required={isRequired}
                aria-invalid={hasErrors && showErrors}
                aria-describedby={errorIds} />
              {option.label}
            </label>
          </div>
        ))}
      </fieldset>
    );
  }
}

CheckboxElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.any,
  defaultValue: PropTypes.array,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (CheckboxElement);



// WEBPACK FOOTER //
// src/common/form-elements/checkbox-element-folder/checkbox-element.js